import type { UserResponse } from '@shared/schemas';

import {
  emptyDraft,
  type LoadStatus,
  type SaveStatus,
  type UserDraft,
  type ValidationErrors,
} from '../../_shared/domain/user-draft.model';
import type { EditUserError } from '../domain/edit-user-error';

/**
 * Redux state for the Edit-user form. Beyond the shared draft + save lifecycle,
 * Edit tracks the loaded user (for the header), the read-only licence name, and
 * the load lifecycle. Every field is serialisable.
 */
export interface EditUserState {
  /** The user being edited (null until loaded / when not found). */
  user: UserResponse | null;
  draft: UserDraft;
  /** Licence display name (read-only in Edit). */
  licenceName: string;
  loadStatus: LoadStatus;
  saveStatus: SaveStatus;
  validationErrors: ValidationErrors;
  error: EditUserError | null;
}

export const initialState: EditUserState = {
  user: null,
  draft: emptyDraft,
  licenceName: '',
  loadStatus: 'idle',
  saveStatus: 'idle',
  validationErrors: {},
  error: null,
};
